import { motion, AnimatePresence } from "framer-motion"
import "./OperationLogs.css"

function OperationLogs({ logs, onClear }) {
  return (
    <div className="operation-logs">
      <div className="logs-header">
        <h2>Operation Logs</h2>
        {onClear && logs.length > 0 && (
          <button className="clear-logs-button" onClick={onClear}>
            Clear
          </button>
        )}
      </div>

      <div className="logs-content">
        {logs.length === 0 ? (
          <p className="empty-logs">No operations performed yet.</p>
        ) : (
          <div className="logs-list">
            <AnimatePresence>
              {logs.map((log, index) => (
                <motion.div
                  key={index}
                  className={`log-entry log-${log.type}`}
                  initial={{ opacity: 0, x: -20 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.3 }}
                >
                  <div className="log-timestamp">{log.timestamp}</div>
                  <div className="log-message">{log.message}</div>
                </motion.div>
              ))}
            </AnimatePresence>
          </div>
        )}
      </div>
    </div>
  )
}

export default OperationLogs
